var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#1A73E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48.38,
    height: 49.46,
    transform: "translate(25.8201 25.26)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_110_9143",
    transform: "scale(0.00757576 0.00740741)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_110_9143",
    width: 132,
    height: 135,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACHCAMAAADgDgE7AAAAe1BMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////NgkbwAAAAKHRSTlMAgEBIR38wEGDwv6DvINBQkAXPF7Dg33Ab9duJb6Z4Nioj5sG1mlpsXdCg1wAABBlJREFUeNrtnOt2oyAQgJFW8I61RtM2vV923v8Jt4EkY9SasAOedI/fn9KeSj6ZgTBRwxZ+AetrH6yZDTfgB2bDLfjhZpFYJBaJReKUxAWsmDGzQgSaBADSgEYKAIlutTn7FwIA4IwGB4CAGRaJRWKRWCQuVkJdgsS2D3UJEvzXS0QA0DIaJUpQMptGoisvAnK7F2A0KqoEA4CK0aCfR0E+DQEAtYusotDSczsiZ+Z2iykYiZycFJkOKI0VAORjdnz69OTGHKV0ShAJBiFVYZ00oMmSkI8rhJl2N9GIGKPHo+nkeplBjyQU/WPMPwVbm21LMioFzo9808AoTRodQiZVDQaxG8iUkYkOi43KYIIsKcPwO1Kwp9RpiadATk1l3gRsWEk9ELhckoeikfrdzIJYmITCgaBnRWl0zgbHrmZOELpTO4tov+bHOaOz7ywT2sLGQZl56orCziJWegAzDIYL8hgAKnmmRSyMg5ki7hDaAsfitIPKdk3HFhiR0w4RNh0SAVrQHOhjgTN1yiHEpnMLnHzxpEPqywEtsDmgyA8OhWR+kAV8E45aHF5Y+nRAixQtRhwqggPBYuiQMq+YgNdSWwwdcv8OaFFpi1XfQWS2DnQLiRYxOkRsDqKDBe61BMGBYJFsW3VnUyub2RzQotVDgQNRmg3YfJT7kgg0q+1AEMaBsNdShzIgNaNjPy/oJWqgf24RWHTOCd/tH2Wxz9GEUHSSPwTiPGckCXo4kFpnyaxUgwxoZ0/MaHilNTcZOh+RWSUNovPJbTafBe/UNTKDBiukeSxwP8/xF2zOYjGsKQTOzBktNuigUYHo+nlfN0/XFDz2bYE1hThZm3gEa4opC6+r1nhNEaX82KLwZoEONTrg7OgifVqM1xSRWayHFpVkzsGaYvCKyeBvCVp4cAgsaxOnYE1BtvDvgJRuLabrGvny/HozUSG5ox51yJ+S+ztTid5//LllPVrcdLggGHF4eSjgmPenfCQvFHNDPjyl10cYo7wdXCVvHKVF0g/u+hN+4C6QDJErZwFR/QsG6g5+5k30SiTImQOa3iL1ANN89TI6dVTwrXpL8jSfvXTK3WREhA73cJrkeIaUTqZGjNn2DueQHh2eMSrt0ak8wnm0bkvUqrtfeIJzue6u3ik9GpiWL3A2mWQG6SAeCqNhd4n4AQ8iz4+yE9IrCwd84YBeAlSdfew92PDIDJyeFJ2UiMCOZ/qtWsMeErABU4mcmRw7k2DJW0eefocTNu14xuWKO7qh8wNseXB/P2YGtiTOJSRYs3IuIcAe7CNwI6HAnlfXEi3Yw11LhGDPl2sJcQfW3LqUMHBb5K6PS7mDfZGgSYhQo58DC2noUla3NvklPEOcLc8QLxKLxCLx/0lcxLcusPWVD9Zs4RfwF3h/z14caCc+AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveTime);
export default __webpack_public_path__ + "static/media/saveTime.60c72ced7968aea3cacee38d4934dbe3.svg";
export { ForwardRef as ReactComponent };